import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { Box, Container, CssBaseline } from "@mui/material";


import Header from "./Header";
import FooterReserved from "./innerComponent/FooterReserved";
import LargeFooter from "./ProfileLayout/FOOTER/LargeFooter";
import ScrollToTop from "../components/other/ScrollToTop";

import "./innerComponent/styles/navbarmenu.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Layout = ({ children }) => {
  const memoizedHeader = useMemo(() => <Header />, []);
  const memoizedFooter = useMemo(() => <LargeFooter />, []);
  const memoizedFooterReserved = useMemo(() => <FooterReserved />, []);

  return (
    <React.Fragment>
      <CssBaseline />
      <ScrollToTop />
      <Container
        maxWidth="false"
        disableGutters={true}
        sx={{
          maxWidth: "100%",
          alignItem: "center",
          backgroundColor: 'white.main',
          minHeight: "100vh", // Makes it full height
        }}
      >
        {memoizedHeader}
        <Container
          maxWidth="false"
          sx={{
            minHeight: "40vh",
            backgroundColor: 'transparent',
            alignItem: "center",
            position: "relative",
          }}
          disableGutters
        >
          <Box
            component={"div"}
            sx={{
              height: {
                sm: 120,
                lg: 114
              },
            }}
          />


          <Outlet>
            {children}
          </Outlet>

        </Container>
        {memoizedFooter}
        {memoizedFooterReserved}
      </Container>
    </React.Fragment>
  );
};

export default React.memo(Layout);
